export { default as StorageStore, StorageKey } from './store'
